import Vue from 'vue';
import VueI18n from 'vue-i18n';
import Cookies from 'js-cookie';
import { Locale } from 'vant';

import enUS from 'vant/es/locale/lang/en-US';
import zhCN from 'vant/es/locale/lang/zh-CN';
import jaJP from 'vant/es/locale/lang/ja-JP';
import esES from 'vant/es/locale/lang/es-ES';
import deDE from 'vant/es/locale/lang/de-DE';
import frFR from 'vant/es/locale/lang/fr-FR';



// 自定义语言包
import enLocale from './en';
import zhLocale from './zh';
import koLocale from './ko';
import jaLocale from './ja';
import hiLocale from './hi';
import esLocale from './es';
import ptLocale from './pt';
import deLocale from './de';
import frLocale from './fr';
import pyLocale from './ru';


Vue.use(VueI18n);

const messages = {
  en: {
    ...enLocale,
    ...enUS,
  },
  zh: {
    ...zhLocale,
    ...zhCN,
  },
  ko: {
    ...koLocale,
    // Vant 没有 ko-KR 语言包，所以这里只使用自定义语言包
  },
  ja: {
    ...jaLocale,
    ...jaJP,
  },
  hi: {
    ...hiLocale,
    // Vant 没有 hi-IN 语言包，所以这里只使用自定义语言包
  },
  es: {
    ...esLocale,
    ...esES,
  },
  pt: {
    ...ptLocale,
    // Vant 没有 pt-BR 语言包，所以这里只使用自定义语言包
  },
  de:{
    ...deLocale,
    ...deDE,
    // Vant 没有 de-DE 语言包，所以这里只使用自定义语言包
  },
  fr:{
    ...frLocale,
    ...frFR
    // Vant 没有 fr-FR 语言包，所以这里只使用自定义语言包
  },
  ru:{
    ...pyLocale,

    // Vant 没有 py-PY 语言包，所以这里只使用自定义语言包
  }

};

export const backGetLang = () => {
  const chooseLanguage = Cookies.get('language')
  if (chooseLanguage) return chooseLanguage

  // if has not choose language
  const language = (navigator.language || navigator.browserLanguage).toLowerCase()
  const locales = Object.keys(messages)
  for (const locale of locales) {
    if (language.indexOf(locale) > -1) {
      return locale
    }
  }
  return 'en'
}
export function getLanguage() {
  const lang = backGetLang()
  const langMap = {
    en: enUS,
    zh: zhCN,
    ko: koLocale, // 使用自定义韩语包
    ja: jaJP,
    hi: hiLocale, // 使用自定义印地语包
    es: esES,
    pt: ptLocale, // 使用自定义葡萄牙语包
    de: deDE,
    fr: frFR,
    ru: pyLocale,
  };

  if (langMap[lang]) {
    Locale.use(lang, langMap[lang])
  } else {
    Locale.use('en', enUS) // fallback to English if language is not found
  }

  return lang
}

const i18n = new VueI18n({
  // set locale
  // options: en | zh | es
  locale: getLanguage(),
  // set locale messages
  messages,
  silentTranslationWarn: true/* 去除警告 */
})

export default i18n
